module.exports = __webpack_public_path__ + "static/img/team-blue.41a729b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team-blue.png
// module id = m0Jp
// module chunks = 0